import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RtHeadingDirective } from './directives/rt-heading.directive';

@NgModule({
  declarations: [RtHeadingDirective],
  imports: [CommonModule],
  exports: [RtHeadingDirective],
})
export class RtHeadingModule {}
